/// <amd-module name="typeahead/core/logging/CollectorTransport"/>

export class CollectorTransport {
    public log(payload: any): void {
        let isBatch = true;
        if (! _.isArray(payload)) {
            isBatch = false;
        }
        let url = "//"
            + window.location.hostname
            + (window.location.port ? ":" + window.location.port : "")
            + "/cl/data"
            + "/typeahead_client_metrics.json?stream=true&persist=true&batch=" + (isBatch ? "true" : "false");
        $.ajax({
                contentType: "application/json; charset=UTF-8",
                url,
                data: JSON.stringify(payload),
                dataType: "json",
                type: "POST",
            },
        );
    }
}
